// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd9f10f8","732":"6d1adbc7","977":"fac48738"}[chunkId] + ".chunk.js";
};